<template>
  <div style="padding-top: 15px">
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-sm-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              <div
                class="row table-responsive"
                style="padding-bottom: 60px; margin: 0 !important"
              >
                <div style="display: flex">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    style="margin-left: 10px"
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".xlsx, .xls"
                    :show-file-list="false"
                  >
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                    <el-button type="primary" @click="submissionTypeC(3)"
                      >Upload</el-button
                    >
                  </el-upload>

                  <!-- <el-upload
                    class="upload-demo"
                    action="#"
                    style="margin-left: 10px"
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".xlsx, .xls"
                    :show-file-list="false"
                  >
                    <el-button type="primary" @click="submissionTypeC(2)"
                      >Physical Upload</el-button
                    >
                  </el-upload> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      total: 0,
      rows: [],
      startDate: "",
      endDate: "",
      ocTable: "",
      ocAction: "",
      multipleSelection: [],
      sortType: "DESC",
      sortField: "id",
      showDetail: false,
      compareDetail: [],
      lastPublishDate: "",
      lastPublisher: "",
      submissionType: "",
      uploadErr:false
    };
  },
  created() {},
  components: {
    draggable,
  },
  methods: {
    submissionTypeC(submissionType) {
      this.submissionType = submissionType;
    },
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.stemupUpload;
      obj.submissionType = this.submissionType;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: "Upload Success",
        type: "success",
      });
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
  mounted() {},
};
</script>
